import { List, useTable } from "@refinedev/antd";
import { Table, Tabs } from "antd";
import { useResourceContext } from "./ResourceContext";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export const ResourceListLayout = ({ title, resource, columns, keyField = "id", actions, details, children }) => {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const { rootState, state, dispatch, tenantName } = useResourceContext();
  const [ searchParams, setSearchParams ] = useSearchParams(); 
  const { tableProps, setCurrent} = useTable({
    resource,
    meta: {
      tenantName,
    },
  });
  useEffect(() => {
    if (
      tableProps.dataSource &&
      tableProps.dataSource.length > 0 &&
      (!state.selectedResources || state.selectedResources.length === 0)
    ) {
      dispatch({ type: "SELECT_RESOURCE", payload: tableProps.dataSource[0] });
      return;
    }
    if (
      !tableProps.loading &&
      rootState.tenantMode &&
      rootState.tenantName &&
      state.selectedResources &&
      state.selectedResources.length > 0
    ) {
      if (state.selectedResources[0].tenant && state.selectedResources[0].tenant != rootState.tenantName) {
        dispatch({
          type: "SELECT_RESOURCE",
          payload: tableProps.dataSource.length > 0 ? tableProps.dataSource[0] : null,
        });
      }
    }
    if(state.selectedResources && state.selectedResources.length > 0 && (!tableProps.dataSource || tableProps.dataSource.length == 0)) {
      dispatch({
        type: "SELECT_RESOURCE",
        payload: null,
      });
    }
  }, [tableProps]);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  useEffect(() => {
    const gotoLast = searchParams.get("toLastPage") === "1";
    const pagination = tableProps?.pagination;
    if(gotoLast && pagination?.total > 0 && pagination.pageSize > 0) {
      const pageCount = Math.ceil(pagination.total / (pagination.pageSize));
      if(pageCount > 0 && pagination.current != pageCount) {
        setCurrent(pageCount);
        searchParams.delete("toLastPage");
        setSearchParams(searchParams, {replace: true });
      }
    }
  }, [ tableProps?.pagination?.total, tableProps?.pagination?.pageSize ])

  if (rootState.tenantMode && rootState.tenantName && !tableProps.loading && tableProps.dataSource) {
    tableProps.dataSource = tableProps.dataSource.filter((r) => !r.tenant || r.tenant == rootState.tenantName);
  }

  return (
    <div>
      <List title={title} headerButtons={actions}>
        <Table
          {...tableProps}
          rowKey={Array.isArray(keyField) ? (record) => keyField.map(field => record[field]).join('-') : keyField}
          size={windowHeight < 1024 ? "small" : "middle"}
          rowSelection={{
            hideSelectAll: true,
            type: "radio",
            selectedRowKeys: state.selectedResources ? 
              state.selectedResources.map((r) => Array.isArray(keyField) ? keyField.map(field => r[field]).join('-') : r[keyField]) : [],
            onSelect: (record, selected) => {
              if (selected) {
                dispatch({ type: "SELECT_RESOURCE", payload: record });
              }
            },
          }}
          columns={columns}
          onRow={(record) => ({
            onClick: () => dispatch({ type: "SELECT_RESOURCE", payload: record }),
          })}
        />
      </List>
      {details && <Tabs items={details} />}
      <div>{children}</div>
    </div>
  );
};
